import { render, staticRenderFns } from "./StepCustomization.vue?vue&type=template&id=fda4ad94&scoped=true&"
import script from "./StepCustomization.vue?vue&type=script&lang=js&"
export * from "./StepCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4ad94",
  null
  
)

export default component.exports